import { css } from "@emotion/react";

export const centered = css`
  text-align: center;
`;
